export default __webpack_public_path__ + "static/media/waves.3af66a4a.png";